module.exports = __webpack_public_path__ + "default-user-media-fc6e83b33852ed9fcbd61b0689892f58.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/img/default-user-media.jpg
// module id = 510
// module chunks = 0